import {Link} from 'react-router'
import {ClimateLedLayout} from './layouts/climate-led.jsx'
import {CompactLayout} from './layouts/compact.jsx'
import {OpsFocusedLayout} from './layouts/ops-focused.jsx'
import {useDashboardLayout} from '../../hooks/use-dashboard-layout.js'
import styles from './dashboard.module.scss'

const LAYOUTS = {
    'climate-led': ClimateLedLayout,
    'compact': CompactLayout,
    'ops-focused': OpsFocusedLayout
}

const FlagIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5 21V4M5 4h11l-2 4 2 4H5"/>
    </svg>
)

export function Dashboard() {
    const {layout} = useDashboardLayout()
    const LayoutComponent = LAYOUTS[layout] || ClimateLedLayout
    return (
        <div className={styles.dashboard}>
            <LayoutComponent/>
            <Link
                to="/issues/new"
                className={styles.report}
                aria-label="Report an issue"
                title="Report issue"
            >
                <FlagIcon/>
            </Link>
        </div>
    )
}
